import { render, staticRenderFns } from "./NotAllowedPage.vue?vue&type=template&id=08daba02&scoped=true&"
import script from "./NotAllowedPage.vue?vue&type=script&lang=ts&"
export * from "./NotAllowedPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotAllowedPage.vue?vue&type=style&index=0&id=08daba02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08daba02",
  null
  
)

export default component.exports